import { render } from "./newaddemployee.vue?vue&type=template&id=8cad8fae&scoped=true"
import script from "./newaddemployee.vue?vue&type=script&lang=js"
export * from "./newaddemployee.vue?vue&type=script&lang=js"

import "./newaddemployee.vue?vue&type=style&index=0&id=8cad8fae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cad8fae"]])

export default __exports__